import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { EyeOffSvg, EyeOnSvg } from '../../../assets/icons';
import { zIndexes } from '../../../utils/zIndexes';
import { IconWrapper } from '../../_atoms/IconWrapper';

const HideResponseToggle = ({
  visible,
  onToggle,
  isHiding,
}: {
  isHiding: boolean;
  visible: boolean;
  onToggle: () => void;
}) => {
  const { t } = useTranslation('Host');
  return (
    <HideResponseContainer
      onClick={e => {
        e.stopPropagation();
        onToggle();
      }}
    >
      <Tooltip
        title={t(
          'You can click the eye to hide responses to guide your participants just as you want',
        )}
      >
        <IconWrapper
          style={visible ? { opacity: 1 } : { opacity: 0 }}
          height="16px"
          width="16px"
        >
          {isHiding ? <EyeOnSvg /> : <EyeOffSvg />}
        </IconWrapper>
      </Tooltip>
    </HideResponseContainer>
  );
};

export default HideResponseToggle;

const HideResponseContainer = styled.div`
  z-index: ${zIndexes('PRESENTER_HIDE_RESPONSE')};
  position: absolute;
  top: 7px;
  right: 7px;
  margin: 0px !important;
`;
